export const version = "networks/5.8.0";
//# sourceMappingURL=_version.js.map